import state from './moduleRevisionState'
import mutations from './moduleRevisionMutations'
import actions from './moduleRevisionActions'
import getters from './moduleRevisionGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}